import React from 'react';
import { View } from 'react-native';
import {
  createStyleSheet,
  UnistylesRuntime,
  useStyles,
} from 'react-native-unistyles';

import { Text } from '@/ui';
import { Image } from '@/ui/image';

const STEPS = [
  'Open your bank app',
  'Find the charge from Eon',
  'Take a screenshot & Upload',
];

export function PaymentInstructions() {
  const { styles } = useStyles(stylesheet);

  return (
    <View style={styles.container}>
      <Image
        source={
          UnistylesRuntime.themeName === 'dark'
            ? require('../../../public/images/verify-payment/bank-charge-dark.png')
            : require('../../../public/images/verify-payment/bank-charge-light.png')
        }
        contentFit="contain"
        style={styles.image}
      />

      <View style={styles.details}>
        <Text type="bodyRegular">
          To confirm this card is yours, upload a screenshot of your Eon charge
          from your bank app.
        </Text>

        <View style={styles.steps}>
          {STEPS.map((step, index) => (
            <View key={step} style={styles.step}>
              <View style={styles.stepCircle}>
                <Text type="bodyBold" style={styles.stepNumber}>
                  {index + 1}
                </Text>
              </View>

              <Text type="bodyRegular">{step}</Text>
            </View>
          ))}
        </View>
      </View>
    </View>
  );
}

const stylesheet = createStyleSheet((theme) => ({
  container: {
    flex: 1,
    gap: 32,
  },
  details: {
    gap: 24,
  },
  image: {
    flex: 1,
    minHeight: 0,
    width: '100%',
  },
  steps: {
    gap: 16,
  },
  step: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 8,
  },
  stepCircle: {
    width: 32,
    height: 32,
    borderRadius: 16,
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: theme.colors.progressBar.active.backgroundColor,
  },
  stepNumber: {
    color: theme.colors.text.inverse,
  },
}));
